export enum DocumentSource {
  GOOGLE_DRIVE = 'google_drive',
  DROPBOX = 'dropbox',
  ONE_DRIVE = 'one_drive',
  URL = 'url',
  ALLPOSIT = 'allposit',
  ALLPOSIT_THUMBNAIL = 'allposit_thumbnail',
}
